"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOWN = exports.NEIGHBORHOOD = exports.COUNTY = exports.CITY = void 0;
exports.CITY = "city";
exports.COUNTY = "county";
exports.NEIGHBORHOOD = "neighborhood";
exports.TOWN = "town";